var React = require('react');

function Tv (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".fa-secondary{opacity:.4}")),React.createElement("path",{"d":"M592 0H48A48 48 0 0 0 0 48v320a48 48 0 0 0 48 48h240v32H112a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h416a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16H352v-32h240a48 48 0 0 0 48-48V48a48 48 0 0 0-48-48zm-16 352H64V64h512z","className":"fa-secondary","key":1}),React.createElement("path",{"d":"M576 352H64V64h512z","className":"fa-primary","key":2})]);
}

Tv.defaultProps = {"viewBox":"0 0 640 512","className":"icon"};

module.exports = Tv;

Tv.default = Tv;
